export default "__VITE_ASSET__04f41a94__"